<template>
<div id="app">
    <div ref="webgl-main-container" class="webgl-main-container"></div>
    <Home />
</div>
</template>

<script>
import Home from './components/Home'
import WebglManager from '@/glxp/webglManager'
import RAF from '@/js/utils/raf'

export default {
    name: 'App',
    components: {
        Home
    },
    mounted() {
        const glxpManager = WebglManager.init(this.$refs['webgl-main-container'])
        RAF.suscribe('webgl-main', glxpManager.render.bind(glxpManager))
    }
}
</script>

<style src="./styles/layout.less" lang="less"></style>
